const buildRoutePath = (routeTemplate, params) => {
  let path = routeTemplate

  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, value)
  }

  return path
}

const appendRouteDetails = (path, options = {}) => {
  const {
    extraPath = '',
    query = null,
    matchNested = false
  } = options

  let nextPath = path

  if (matchNested) {
    nextPath = `${nextPath}/*`
  } else if (extraPath) {
    const trimmedPath = String(extraPath).replace(/^\/+/, '')
    if (trimmedPath) {
      nextPath = `${nextPath}/${trimmedPath}`
    }
  }

  if (query && typeof query === 'object') {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null) return
      params.append(key, String(value))
    })
    const queryString = params.toString()
    if (queryString) {
      nextPath = `${nextPath}?${queryString}`
    }
  }

  return nextPath
}

const ROUTES = {
  ROOT:              '/',
  HOME:              '/home',
  SCAN:              '/scan',
  ABOUT:             '/about',
  PRIVACY:           '/privacy',
  TERMS:             '/terms',
  HOW_IT_WORKS:      '/how-it-works',
  WEDDINGS:          '/weddings',
  VENUES:            '/venues',
  MEETUPS:           '/meetups',
  CHAT:              '/chat',
  LOGIN:             '/login',
  LOGOUT:            '/logout',
  SIGNUP:            '/signup',
  FORGOT_PASSWORD:   '/forgot-password',
  RESET_PASSWORD:    '/reset-password',
  VERIFY_EMAIL:      '/verify-email',
  EVENT_HOST_INVITE: '/event-host-invite',
  GOOGLE_OAUTH_CALLBACK: '/oauth/callback/google',
  GUEST_SIGNUP:      '/guest-signup',
  GUEST_EXPIRED:     '/guest-expired',
  PROFILE:           '/profile',
  UPDATE_PROFILE:    '/update_profile',
  MERCHANT_DASHBOARD:'/merchant/venues',
  MERCHANT_PROFILE:  '/merchant-profile',
  MERCHANT_PROFILE_EDIT: '/merchant-profile/edit',
  MERCHANT_FAVORITE_APPS_EDIT: '/merchant-profile/favorites',
  MERCHANT_APP_VIEW: (appId = ':appId') => buildRoutePath('/merchant/apps/:appId', { appId }),
  MERCHANT_VENUE_CREATE: '/merchant/venues/new',
  MERCHANT_GETTING_STARTED: '/merchant/venues/getting-started',
  MERCHANT_VENUE_SHOW: (venueId = ':venueId') => buildRoutePath('/merchant/venues/:venueId', { venueId }),
  MERCHANT_VENUE_EDIT: (venueId = ':venueId') => buildRoutePath('/merchant/venues/:venueId/edit', { venueId }),
  MERCHANT_VENUE_APPS_EDIT: (venueId = ':venueId') => buildRoutePath('/merchant/venues/:venueId/apps', { venueId }),
  MERCHANT_VENUE_APPS_DISCOVER: (venueId = ':venueId') => buildRoutePath('/merchant/venues/:venueId/apps/discover', { venueId }),
  MERCHANT_VENUE_QR: (venueId = ':venueId') => buildRoutePath('/merchant/venues/:venueId/qr', { venueId }),
  APPS:              '/apps',
  EVENTS:            '/events',
  NEARBY:            '/nearby',
  EVENT_PAGE:        (eventSlug = ':eventSlug', options = {}) => (
    appendRouteDetails(buildRoutePath('/e/:eventSlug', { eventSlug }), options)
  ),
  VENUE_PAGE:        (venueSlug = ':venueSlug') => buildRoutePath('/v/:venueSlug', { venueSlug }),
  CREATE_EVENT:      (createTarget = ':createTarget') => buildRoutePath('/c/:createTarget', { createTarget }),
  CREATE_EVENT_BY_SLUG: (appSlug = ':appSlug')  => buildRoutePath('/a/:appSlug', { appSlug }),
  EVENT_PARTICIPANT: (eventId = ':eventId')     => buildRoutePath('/p/:eventId', { eventId }),
}

export default ROUTES
